import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Group } from '../modal/group';

export const deleteGroupAPI = async (fieldId: string) => {
  const resp = await baseAPI.delete<Group>(`/custom-form/${fieldId}`);
  return resp.data;
};

export const useDeleteGroupMutation = () => {
  return useMutation({
    mutationFn: async ({ fieldId }: { fieldId: string }) => {
      const response = await deleteGroupAPI(fieldId);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.GROUPS,
      });
    },
  });
};
